module.exports = __webpack_public_path__ + "img/footer-background.b65597c1.webp";